import axios from 'axios'
let host = 'api.bcndropshippingelite.com',protocol = 'https';
// let host = 'localhost', protocol = 'http';

let axiosWrap = axios.create({
  method: 'post',
  baseURL: protocol + "://" + host + "/h5.php",
});
axiosWrap.interceptors.request.use(
  config => {
      config.params = {
        _t: new Date().valueOf(),
        ...config.params
      }
    return config
  }, function (error) {
    return Promise.reject(error)
  }
)
export default axiosWrap